import { IDataShape } from '../models/dataShape'
import { ITreeStructure } from '../models/treeStructure'

import { getItemsMap } from './getItemsMap'
import { IOptions, mapDataShapeToTreeStructure } from './mapDataShapeToTreeStructure'

export const getTreeStructure = <T extends IDataShape>(
  data: T[],
  options: IOptions<T>
): ITreeStructure[] => {
  const mappedData = mapDataShapeToTreeStructure(data, options)
  const itemsMap = getItemsMap(data)
  const result: ITreeStructure[] = []

  for (let i = 0; i < mappedData.length; i++) {
    const item = mappedData[i]
    if (item.parentId === null) {
      result.push(item)
      continue
    }

    const mapKey = item.parentId
    const parentIndex = itemsMap[mapKey]
    const parent = mappedData[parentIndex]
    if (!parent) {
      result.push(item)
      continue
    }

    parent.hasChildren = true
    item.parent = mappedData[parentIndex]
    mappedData[parentIndex].nestedItems.push(item)
  }

  return result
}
